import { useEffect, useState } from 'react';
import { useI18n } from '../i18n/useI18n';
import type { DuetInvite } from '../types';

interface Props {
  invite: DuetInvite;
  onAccept: (inviteId: string) => void;
  onDecline: (inviteId: string) => void;
  onExpire?: (inviteId: string) => void;
}

export default function DuetInviteToast({ invite, onAccept, onDecline, onExpire }: Props) {
  const { t } = useI18n();
  const [remaining, setRemaining] = useState(30);

  useEffect(() => {
    const start = Date.now();
    const duration = 30000;
    let raf = 0;
    const tick = () => {
      const elapsed = Date.now() - start;
      const left = Math.max(0, Math.ceil((duration - elapsed) / 1000));
      setRemaining(left);
      if (left > 0) {
        raf = requestAnimationFrame(tick);
      } else if (onExpire) {
        // Garante remoção local mesmo se o evento do servidor se perder.
        onExpire(invite.inviteId);
      }
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, []);

  const progress = (remaining / 30) * 100;

  return (
    <div className="duet-toast" role="alert" aria-live="polite">
      <div className="duet-toast__content">
        <div className="duet-toast__info">
          <div className="duet-toast__title">
            {t('duet.receivedTitle', { name: invite.inviterName })}
          </div>
          <div className="duet-toast__song">{invite.messageTitle || t('duet.unknownSong')}</div>
        </div>
        <div className="duet-toast__actions">
          <button className="btn-primary duet-toast__accept" onClick={() => onAccept(invite.inviteId)}>
            {t('duet.accept')}
          </button>
          <button className="btn-secondary duet-toast__decline" onClick={() => onDecline(invite.inviteId)}>
            {t('duet.decline')}
          </button>
        </div>
      </div>
      <div className="duet-toast__progress-bg">
        <div className="duet-toast__progress-bar" style={{ width: `${progress}%` }} />
      </div>
    </div>
  );
}
